module.exports = __webpack_public_path__ + "static/img/PrestationHomme2.2ab1f2d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationHomme2.jpeg
// module id = nPky
// module chunks = 1